
import { Button } from "@/components/ui/button";
import { RefreshCw } from "lucide-react";

interface ConnectButtonProps {
  isConnecting: boolean;
  isConnected: boolean;
  onClick: () => void;
}

export const ConnectButton = ({ isConnecting, isConnected, onClick }: ConnectButtonProps) => {
  return (
    <Button 
      className="mt-4 w-full" 
      onClick={onClick} 
      disabled={isConnecting}
      variant={isConnected ? "outline" : "default"}
    >
      {isConnecting ? (
        <>
          <RefreshCw className="h-4 w-4 mr-2 animate-spin" />
          Redirecting…
        </>
      ) : isConnected ? (
        "Reconnect Microsoft Account"
      ) : (
        "Connect Microsoft Account"
      )}
    </Button>
  );
};
